<template>
  <div>
    <div class="container-fluid">
      <div class="page-title">
        <div class="row">
          <div class="col-6">
            <h4>{{ stock.id }} {{ stock.name }} <br>{{ stock.company }}</h4>
            <h5 class="ml-3">Intraday <br>{{ date }}</h5>
          </div>
          <div class="col-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ path: '/' }"><feather type="home"></feather></router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ path: '/stock/board' }">Stock</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ path: '/stock/ticker/'+stock.name }" v-if="stock">{{ stock.id }} {{ stock.name }}</router-link>
              </li>
              <li class="breadcrumb-item active">Intraday {{ date }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row second-chart-list third-news-update">
        <div class="col-xl-4 xl-50 appointment-sec box-col-6">
          <div class="row">
            <div class="col-xl-12">
              <px-card :actions="false" class="card-no-border">
                <div slot="headerCustom">
                  <div class="header-top">
                    <h5 class="m-0">Top {{ topSelect }}</h5>
                    <div class="card-header-right-icon">
                      <select class="button btn btn-primary" v-model="topSelect">
                        <option value="hl5">High Low 5</option>
                        <option value="gain">Gain</option>
                        <option value="lose">Lose</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="appointment-table table-responsive">
                    <table class="table table-bordernone">
                      <tbody v-if="topSelect==='hl5'">
                      <tr :data="tr" :key="i" v-for="(tr, i) in hl5">
                        <td class="img-content-box">
                          <span class="font-roboto">Date</span>
                          <span class="d-block">{{ $moment(tr.date).format('DD MMM') }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Open</span>
                          <span class="d-block">{{ tr.open }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">High</span>
                          <span class="d-block">{{ tr.high }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Low</span>
                          <span class="d-block">{{ tr.low }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Close</span>
                          <span class="d-block">{{ tr.close }}</span>
                        </td>
                        <td>
                          <span class="font-roboto">Change</span>
                          <span :class="{ 'd-block':true, 'font-success':(tr.close/tr.open)>1.1, 'font-danger':(tr.close/tr.open)<=1 }"><b>{{ Math.round(tr.close/tr.open*100-100) }}%</b></span>
                        </td>
                        <td>
                          <span class="font-roboto">Volatile</span>
                          <span :class="{ 'd-block':true, 'font-success':(tr.high/tr.low)>1.15, 'font-danger':(tr.high/tr.low)<=1 }"><b>{{ Math.round(tr.high/tr.low*100-100) }}%</b></span>
                        </td>
                      </tr>
                      </tbody>
                      <tbody v-if="topSelect==='gain'">
                      <tr :data="tr" :key="i" v-for="(tr, i) in gain">
                        <td class="img-content-box">
                          <span class="font-roboto">Date</span>
                          <span class="d-block">{{ $moment(tr.date).format('DD-MM-YY') }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Open</span>
                          <span class="d-block">{{ tr.open }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">High</span>
                          <span class="d-block">{{ tr.high }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Low</span>
                          <span class="d-block">{{ tr.low }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Close</span>
                          <span class="d-block">{{ tr.close }}</span>
                        </td>
                        <td>
                          <span class="font-roboto">Change</span>
                          <span :class="{ 'd-block':true, 'font-success':(tr.close/tr.open)>=1.1, 'font-primary':(tr.close/tr.open)<1.1 }"><b>{{ Math.round(tr.close/tr.open*100-100) }}%</b></span>
                        </td>
                        <td>
                          <span class="font-roboto">Volatile</span>
                          <span :class="{ 'd-block':true, 'font-success':(tr.high/tr.low)>=1.2, 'font-primary':(tr.high/tr.low)<1.2 }"><b>{{ Math.round(tr.high/tr.low*100-100) }}%</b></span>
                        </td>
                      </tr>
                      </tbody>
                      <tbody v-if="topSelect==='lose'">
                      <tr :data="tr" :key="i" v-for="(tr, i) in lose">
                        <td class="img-content-box">
                          <span class="font-roboto">Date</span>
                          <span class="d-block">{{ $moment(tr.date).format('DD-MM-YY') }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Open</span>
                          <span class="d-block">{{ tr.open }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">High</span>
                          <span class="d-block">{{ tr.high }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Low</span>
                          <span class="d-block">{{ tr.low }}</span>
                        </td>
                        <td class="img-content-box">
                          <span class="font-roboto">Close</span>
                          <span class="d-block">{{ tr.close }}</span>
                        </td>
                        <td>
                          <span class="font-roboto">Change</span>
                          <span :class="{ 'd-block':true, 'font-danger':(tr.close/tr.open)<=0.9, 'font-warning':(tr.close/tr.open)>0.9 }"><b>{{ Math.round(tr.close/tr.open*100-100) }}%</b></span>
                        </td>
                        <td>
                          <span class="font-roboto">Volatile</span>
                          <span :class="{ 'd-block':true, 'font-success':(tr.high/tr.low)>=1.2, 'font-primary':(tr.high/tr.low)<1.2 }"><b>{{ Math.round(tr.high/tr.low*100-100) }}%</b></span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </px-card>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-12 xl-50 calendar-sec box-col-6">
          <px-card>
            <div slot="with-padding" class="chat-box">
              <div class="setting-dot">
                <div class="setting-bg-primary date-picker-setting position-set pull-right">
                  <i class="fa fa-spin fa-cog"></i>
                </div>
              </div>
              <functional-calendar ref="Calendar" :date-format="'yyyy-mm-dd'" @dayClicked="dayClicked" :markedDates="[$moment(date).format('YYYY-MM-DD')]"></functional-calendar>
            </div>
          </px-card>
        </div>
        <div class="col-sm-12 col-xl-12 box-col-12">
          <div class="card">
            <highcharts class="chartWrapper" :constructor-type="'stockChart'" :options="chartOptions"></highcharts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data: function () {
    return {
      ticker: this.$route.params.ticker,
      date: this.$route.params.date || this.$moment().format('YYYY-MM-DD'),
      stock: null,
      topSelect: 'hl5',
      gain: [],
      lose: [],
      hl5: [],
      ohlc: [],
      vol: [],
      chartOptions: {
        chart: {
          zoomType: 'x',
          height: 600,
          responsive: true,
          maintainAspectRatio: false
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        yAxis: [{
          labels: {
            align: 'right',
            x: -3
          },
          title: {
            text: 'OHLC'
          },
          height: '60%',
          lineWidth: 2,
          resize: {
            enabled: true
          }
        }, {
          labels: {
            align: 'right',
            x: -3
          },
          title: {
            text: 'Volume'
          },
          top: '65%',
          height: '35%',
          offset: 0,
          lineWidth: 2
        }],
        tooltip: {
          split: true
        },
        credits: { enabled: false },
        xAxis: [{
          tickLength: 0,
          lineWidth: 1,
          labels: {
            enabled: false
          },
        }],
        series: [{
          type: 'column',
          name: 'Volume',
          data: [],
          yAxis: 1
        }, {
          type: 'candlestick',
          name: '',
          id: '',
          data: []
        }]
      },
    }
  },
  computed: {
    title: function () { return this.stock ? this.stock.id+' '+this.stock.name+' : '+this.stock.company + ' [Intraday '+this.date+']' : 'Intraday' },
    markedDates: function () { return [this.$moment(this.date).format('YYYY-m-d')] }
  },
  watch: {
    title: { immediate: true, handler() { document.title = this.title } },
    '$route.params.date': function (val) { this.date = val },
    date: function () { this.init() },
    topSelect: function (val) {
      if(val === 'gain') this.fetchTopGain()
      if(val === 'lose') this.fetchTopLose()
      if(val === 'hl5') this.fetchHL5()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.match(this.ticker)
    },
    match(ticker) {
      this.stock = this.$store.state.menu.stocks.find(s => s.id===ticker || s.name===ticker)
      this.chartOptions.title.text = this.stock.id+' '+this.stock.name+' : '+this.stock.company
      this.chartOptions.subtitle.text = '2021'
      this.chartOptions = { ...this.chartOptions }
      if(!this.date) this.date = this.stock.date
      this.fetchData()
      this.fetchHL5()
    },
    dayClicked(val) {
      this.date = this.$moment(val.date).format('YYYY-MM-DD')
      this.$router.push('/stock/ticker/'+this.stock.name+'/date/'+this.date)
    },
    fetchData() {
      this.$http.get('/api/stock/intraday/'+this.stock.name+'/'+this.date)
          .then(({data}) => {
            this.ohlc = data.data.map(d => ([d[0], d[1], d[2], d[3], d[4]]))
            this.vol = data.data.map(d => ([d[0], d[5]]))
            this.chartOptions.series[1].name = this.stock.name
            this.chartOptions.series[1].id = this.stock.id
            this.chartOptions.series[1].data = this.ohlc
            this.chartOptions.series[0].data = this.vol
            this.chartOptions.yAxis[0].plotLines = [
              {
                color: 'orange',
                dashStyle: 'dash',
                width: 2,
                value: data.historical[1].close,
                label: {
                  text: 'Yesterday Close : '+data.historical[1].close,
                  align: 'center'
                },
                style: {
                  fontWeight: 'bolder'
                }
              },
              {
                color: 'blue',
                dashStyle: 'dash',
                width: 2,
                value: data.historical[1].high,
                label: {
                  text: 'Yesterday High : '+data.historical[1].high,
                  align: 'right'
                },
                style: {
                  fontWeight: 'bolder'
                }
              },
              {
                color: 'red',
                dashStyle: 'dash',
                width: 2,
                value: data.historical[1].low,
                label: {
                  text: 'Yesterday Low : '+data.historical[1].low,
                  align: 'right'
                },
                style: {
                  fontWeight: 'bolder'
                }
              },
              {
                color: 'blue',
                dashStyle: 'dash',
                width: 2,
                value: Math.max(...data.historical.filter(d => d.date !== data.historical[0].date).map(d => d.high)),
                label: {
                  text: 'Week High : '+Math.max(...data.historical.filter(d => d.date !== data.historical[0].date).map(d => d.high)),
                },
                style: {
                  fontWeight: 'bolder'
                }
              },
              {
                color: 'red',
                dashStyle: 'dash',
                width: 2,
                value: Math.min(...data.historical.filter(d => d.date !== data.historical[0].date).map(d => d.low)),
                label: {
                  text: 'Week Low : '+Math.min(...data.historical.filter(d => d.date !== data.historical[0].date).map(d => d.low)),
                },
                style: {
                  fontWeight: 'bolder'
                }
              }
            ]
            this.chartOptions.subtitle.text = data.historical[0].close+' - [Week:'+Math.min(...data.historical.filter(d => d.date !== data.historical[0].date).map(d => d.low))+'~'+Math.max(...data.historical.filter(d => d.date !== data.historical[0].date).map(d => d.high))+']'
            this.chartOptions = { ...this.chartOptions }
            this.date = data.filter.to
          })
          .catch(e => console.log(e.message))
    },
    fetchTopGain() {
      this.$http.get(`/api/stock/scan/gain/${this.stock.name}?pct=5&limit=8`)
          .then(({data}) => {
            this.gain = data.gain.map(h => ({ ...h }))
          })
          .catch(e => console.log(e.message))
    },
    fetchTopLose() {
      this.$http.get(`/api/stock/scan/lose/${this.stock.name}?pct=5&limit=8`)
          .then(({data}) => {
            this.lose = data.lose.map(h => ({ ...h }))
          })
          .catch(e => console.log(e.message))
    },
    fetchHL5() {
      this.$http.get(`/api/stock/scan/hl5/${this.stock.name}?limit=8`)
          .then(({data}) => {
            this.hl5 = data.hl5.map(h => ({ ...h }))
          })
          .catch(e => console.log(e.message))
    }
  }
}
</script>